// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__1OQJy","bigColWidth":"Table_bigColWidth__1XS8v","biggerColWidth":"Table_biggerColWidth__2fWL_","row":"Table_row__IjcdX","col":"Table_col__3VsP-"};